import React from 'react';
import { BookOpen, Award, AlertTriangle } from 'lucide-react';
export function HiddenKnowledgeSection() {
  return <section className="w-full bg-gray-800 py-16 px-4" data-id="element-140">
      <div className="max-w-5xl mx-auto" data-id="element-141">
        <div className="flex items-center justify-center mb-10" data-id="element-142">
          <BookOpen size={32} className="text-amber-500 mr-3" data-id="element-143" />
          <h2 className="text-3xl font-bold text-white" data-id="element-144">Covert Authority</h2>
        </div>
        <div className="bg-gray-900 rounded-lg p-6 mb-10 border border-gray-700" data-id="element-145">
          <div className="flex items-start mb-6" data-id="element-146">
            <Award size={28} className="text-amber-500 mr-3 mt-1 flex-shrink-0" data-id="element-147" />
            <div data-id="element-148">
              <h3 className="text-xl font-semibold text-gray-100 mb-2" data-id="element-149">
                Proven Leadership
              </h3>
              <p className="text-lg text-gray-300" data-id="element-150">
                Charlie Kirk didn't wait to be rich or famous. At 18, he was
                already moving crowds. Today, he leads one of the most
                influential movements in America.
              </p>
              <p className="text-xl font-bold text-amber-400 mt-4" data-id="element-151">
                "How did he do it? With principles, storytelling… and a method."
              </p>
            </div>
          </div>
        </div>
        <div className="mb-10" data-id="element-152">
          <h3 className="text-2xl font-semibold text-center text-white mb-6" data-id="element-153">
            Now, that method can be yours.
          </h3>
          <div className="grid md:grid-cols-3 gap-6" data-id="element-154">
            <div className="bg-gray-900 rounded-lg shadow-md p-5 border border-gray-700" data-id="element-155">
              <div className="flex items-center mb-4" data-id="element-156">
                <AlertTriangle size={24} className="text-amber-500 mr-2" data-id="element-157" />
                <h4 className="text-lg font-medium text-gray-200" data-id="element-158">
                  Principles
                </h4>
              </div>
              <p className="text-gray-300" data-id="element-159">
                Learn the foundational principles that create real authority and
                influence.
              </p>
            </div>
            <div className="bg-gray-900 rounded-lg shadow-md p-5 border border-gray-700" data-id="element-160">
              <div className="flex items-center mb-4" data-id="element-161">
                <AlertTriangle size={24} className="text-amber-500 mr-2" data-id="element-162" />
                <h4 className="text-lg font-medium text-gray-200" data-id="element-163">
                  Storytelling
                </h4>
              </div>
              <p className="text-gray-300" data-id="element-164">
                Master the art of narrative that moves people to action.
              </p>
            </div>
            <div className="bg-gray-900 rounded-lg shadow-md p-5 border border-gray-700" data-id="element-165">
              <div className="flex items-center mb-4" data-id="element-166">
                <AlertTriangle size={24} className="text-amber-500 mr-2" data-id="element-167" />
                <h4 className="text-lg font-medium text-gray-200" data-id="element-168">Structure</h4>
              </div>
              <p className="text-gray-300" data-id="element-169">
                Implement the proven framework that builds movements and creates
                change.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}